import React, { FC } from 'react'

const CardRight: FC = ({ children }) => <div className='card-container__right'>{children}</div>

export default CardRight
